<template>
  <div>
    <Hero id="inicio" />
       <!-- About Us Section Start -->
       <About id="about" />
       <!-- About Us Section End -->
             <!-- Logos Section Start -->
      <LogosMarcas />
      <!-- Logos Section End -->
        <!-- Our Services Section Start -->
        <OurServices id="services" />
        <!-- Our Services Section End -->
    <!-- Best Service Section Start -->
    <WhyChoose id="whyus" />
    <!-- Best Service Section End -->

    <!-- Best Service Section Start -->
    <WhatWeDo id="metricas" />
    <!-- Best Service Section End -->
         <!-- Best Service Section Start -->
    <ContactUs id="contact" />
    <!-- Best Service Section End -->
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from  '../components/Hero.vue'
import About from '../components/About.vue'
import OurServices from '../components/OurServices.vue'
import WhyChoose from '../components/WhyChoose.vue'
import WhatWeDo from '../components/WhattWeDo.vue'
import ContactUs from '../components/ContactUs.vue'
import LogosMarcas from '../components/LogosMarcas.vue'
export default {
  name: 'HomeView',
  components: {
    Hero,
     About,
    OurServices,
    WhyChoose,
    WhatWeDo,
    ContactUs,
    LogosMarcas
  }
}
</script>
